<template>
  <v-btn :color="color" :style="{ width: width + 'px' }">
    <span v-if="showIcon">
      <span v-if="iconPlacement == 'right'">
        <span :class="textAlignment">{{ text }}</span> <v-icon :class="iconPlacement">{{ icon }}</v-icon>
      </span>
      <span v-else>
        <v-icon :class="iconPlacement">{{ icon }}</v-icon> <span :class="textAlignment">{{ text }}</span>
      </span>
    </span>
    <span v-else>
      <span :class="textAlignment">{{ text }}</span>
    </span>
  </v-btn>
</template>

<script>
export default {
  name: 'multiuseButton',
  props: {
    color: null,
    showIcon: null,
    icon: null,
    iconPlacement: null,
    text: null,
    textAlignment: null,
    width: null
  }
}
</script>

<style scoped lang="scss">
  .right {
    position: relative;
    right: -12px;
  }

  .left {
    position: relative;
    left: -12px;
  }

  .center {
    text-align: center;
  }
</style>
